export default "__VITE_ASSET__DkMR$W3W__"